import React from 'react'

import Link from 'components/Link'
import Logo from 'components/Logo'
import Rating from 'components/Rating'
import { useEventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'

import TextBase from '../TextBase'

import classes from './Alternatives.module.scss'

const Alternatives = ({ title, text, alternativesContent, alternatives }) => {
  const { down } = useViewport()
  const { addEvent } = useEventContext({
    name: 'engagement_product_click',
    engagementComponent: 'product_alternatives',
  })
  const alternativesText = alternativesContent.reduce((acc, alternative) => {
    return {
      ...acc,
      [alternative.slug]: alternative.description,
    }
  }, {})

  return (
    <>
      <TextBase title={title} text={text} className={classes.text} />
      {alternatives.map(alternative => (
        <div className={classes.root} key={alternative.id}>
          <div className={classes.header}>
            <div className={classes.nameLogoContainer}>
              <Link
                href={alternative.spotlightUrl}
                {...addEvent({
                  engagementDestination: 'go-to_product-details',
                  engagementDetails: 'logo-product',
                  productClickUUID: alternative.id,
                })}
              >
                <Logo className={classes.logo} src={alternative.logoUrl} alt={`${alternative.name} Logo`} />
              </Link>
              <Link
                variant="heading-sm"
                className={classes.link}
                href={alternative.spotlightUrl}
                {...addEvent({
                  engagementDestination: 'go-to_product-details',
                  engagementDetails: 'text-link_product-name',
                  productClickUUID: alternative.id,
                })}
              >
                {alternative.name}
                {alternative.globalProductId}
              </Link>
            </div>

            <Rating.Link
              average={alternative.reviewSummary.overallRating}
              totals={alternative.reviewSummary.totalReviews}
              href={alternative.reviewsUrl}
              isCompact={down('xs')}
              analyticsEvent={{
                name: 'engagement_product_click',
                engagementComponent: 'product_alternatives',
                engagementDestination: 'go-to_reviews',
                engagementDetails: 'text-link_review-count',
                productClickUUID: alternative.id,
              }}
            />
          </div>
          <TextBase text={alternativesText[alternative.slug]} />
        </div>
      ))}
    </>
  )
}

export default Alternatives
